import {
  DashboardIcon,
  DraftIcon,
  AppliedIcon,
  ApprovalIcon,
  IncentiveClaimIcon,
  SettingsIcon,
  TransactionIcon,
  AdminDashboardIcon,
  RegisterUserIcon,
  UserClockIcon,
  FileSignatureIcon,
  NewRecordIcon,
  CancelApplicationIcon,
  PendingApplicationIcon,
  ApprovedApplicationIcon,
  UserShieldIcon,
  AddUserIcon,
  RolesIcon,
  PermissionIcon,
  NotificationIcon,
  RepsortsIcon,
  FCIcon,
  MobileIcon,
} from "../icons/SidebarIcons.jsx";

export const userSidebarMenu = [
  {
    title: { en: "Dashboard", hi: "डैशबोर्ड" },
    icon: DashboardIcon,
    path: "/dashboard",
  },
  {
    title: { en: "Apply Incentive Claim", hi: "प्रोत्साहन आवेदन करें" },
    icon: IncentiveClaimIcon,
    path: "/apply-incentive-claim",
  },
  {
    title: { en: "Draft", hi: "अधूरा" },
    icon: DraftIcon,
    path: "/draft-applications",
  },
  {
    title: { en: "Applied", hi: "जमा आवेदन" },
    icon: AppliedIcon,
    path: "/applied-applications",
  },
  {
    title: { en: "Approval", hi: "मंजूर आवेदन" },
    icon: ApprovalIcon,
    path: "/approved-applications",
  },
  {
    title: { en: "Payment Done", hi: "भुगतान पूर्ण" },
    icon: ApprovalIcon,
    path: "/payment-done-applications",
  },
  {
    title: { en: "Transaction", hi: "लेन-देन" },
    icon: TransactionIcon,
    path: "/application-transactions",
  },
];

export const adminSidebarMenu = [
  {
    title: { en: "Admin Dashboard", hi: "एडमिन डैशबोर्ड" },
    icon: AdminDashboardIcon,
    path: "/admin/dashboard",
  },
  {
    title: { en: "Registered Users", hi: "रजिस्टर्ड यूज़र" },
    icon: RegisterUserIcon,
    path: "/admin/registered-users",
  },
  {
    title: { en: "TIFC Applications", hi: "TIFC आवेदन" },
    icon: UserClockIcon,
    path: "/admin/tifc/applications",
  },
  {
    title: { en: "DLCT Applications", hi: "DLCT आवेदन" },
    icon: UserClockIcon,
    path: "/admin/dlct/applications",
  },
  {
    title: { en: "SLAC Applications", hi: "SLAC आवेदन" },
    icon: UserClockIcon,
    path: "/admin/slac/applications",
  },
  {
    title: { en: "Pending Applications", hi: "लंबित आवेदन" },
    icon: FileSignatureIcon,
    path: "",
    children: [
      {
        title: { en: "Nodal Pending", hi: "नोडल लंबित" },
        icon: PendingApplicationIcon,
        path: "/admin/nodal-pending-applications",
      },
      {
        title: { en: "Officers Pending", hi: "अधिकारी लंबित" },
        icon: PendingApplicationIcon,
        path: "/admin/officer-pending-applications",
      },
      {
        title: { en: "User Pending", hi: "यूज़र लंबित" },
        icon: UserClockIcon,
        path: "/admin/user-pending-applications",
      },
    ],
  },
  {
    title: { en: "Incentive Claim Management", hi: "प्रोत्साहन आवेदन मैनेजमेंट" },
    icon: FileSignatureIcon,
    path: "",
    children: [
      {
        title: { en: "All Applications", hi: "सभी आवेदन" },
        icon: FileSignatureIcon,
        path: "/admin/all-applications",
      },
      {
        title: { en: "New", hi: "नए आवेदन" },
        icon: NewRecordIcon,
        path: "/admin/new-applications",
      },
      {
        title: { en: "Nodal Incomplete Information", hi: "नोडल अधूरी जानकारी" },
        icon: DraftIcon,
        path: "/admin/nodal-incomplete-information-applications",
      },
      {
        title: { en: "Incomplete Documents(TIFC)", hi: "अधूरे कागज़ (TIFC)" },
        icon: DraftIcon,
        path: "/admin/incomplete-document-pending-applications",
      },
      {
        title: { en: "Incomplete Information(TIFC)", hi: "अधूरी जानकारी (TIFC)" },
        icon: DraftIcon,
        path: "/admin/incomplete-information-applications",
      },
      {
        title: { en: "Verified(TIFC)", hi: "जांच पूरी (TIFC)" },
        icon: ApprovalIcon,
        path: "/admin/tifc-verified-applications",
      },
      {
        title: { en: "Unverified(DLCT)", hi: "जांच बाकी (DLCT)" },
        icon: UserClockIcon,
        path: "/admin/dlct-unverified-applications",
      },
      {
        title: { en: "Verified(DLCT)", hi: "जांच पूरी (DLCT)" },
        icon: ApprovalIcon,
        path: "/admin/dlct-verified-applications",
      },
      {
        title: { en: "Rejected(SLAC)", hi: "रद्द (SLAC)" },
        icon: CancelApplicationIcon,
        path: "/admin/rejected-applications",
      },
      {
        title: { en: "Approved(SLAC)", hi: "मंजूर (SLAC)" },
        icon: ApprovedApplicationIcon,
        path: "/admin/approved-applications",
      },
      {
        title: { en: "Payment Done", hi: "भुगतान पूर्ण" },
        icon: ApprovedApplicationIcon,
        path: "/admin/payment-done-applications",
      },
    ],
  },
  {
    title: { en: "DDO Management", hi: "DDO मैनेजमेंट" },
    icon: FCIcon,
    path: "",
    children: [
      {
        title: { en: "DDO Applications", hi: "DDO आवेदन" },
        icon: NewRecordIcon,
        path: "/admin/ddo/applications",
      },
      {
        title: { en: "All Transactions", hi: "सभी लेन-देन" },
        icon: TransactionIcon,
        path: "/admin/transactions",
      },
    ],
  },
  {
    title: { en: "Admin Management", hi: "एडमिन मैनेजमेंट" },
    icon: UserShieldIcon,
    path: "",
    children: [
      {
        title: { en: "State Officers", hi: "राज्य अधिकारी" },
        icon: AddUserIcon,
        path: "/admin/state-officers",
      },
      {
        title: { en: "District Officers", hi: "जिला अधिकारी" },
        icon: AddUserIcon,
        path: "/admin/district-officers",
      },
    ],
  },
  {
    title: { en: "Settings", hi: "सेटिंग्स" },
    icon: SettingsIcon,
    path: "",
    children: [
      {
        title: { en: "Configurations", hi: "सेटअप" },
        icon: MobileIcon,
        path: "/admin/configurations",
      },
    ],
  },
];
